<template>
  <section class="flex flex-col gap-4 rounded-3xl border border-edge bg-panel p-4 sm:p-6">
    <div class="flex items-baseline justify-between">
      <h2 class="font-display text-[22px] font-extrabold sm:text-[26px]">Hall of Shame</h2>
      <span class="text-xs text-slate-400 sm:text-sm">Top 3 Strafen</span>
    </div>

    <p v-if="podium.length === 0" class="py-6 text-center text-slate-400">Noch keine Strafen – vorbildlich!</p>

    <div v-else class="grid grid-cols-3 items-end gap-2 sm:gap-3">
      <div v-for="entry in podium" :key="entry.name" class="flex flex-col items-center gap-2">
        <span
          class="flex h-[52px] w-[52px] items-center justify-center rounded-full border-[3px] border-panel text-lg font-semibold sm:h-[60px] sm:w-[60px]"
          :style="{ backgroundColor: entry.color, color: readableTextOn(entry.color), boxShadow: `0 0 0 2px ${entry.color}` }"
        >
          {{ entry.name.charAt(0) }}
        </span>
        <span class="max-w-full truncate text-sm font-semibold sm:text-[15px]">{{ entry.name }}</span>
        <div
          class="flex w-full flex-col items-center gap-0.5 overflow-hidden rounded-b rounded-t-xl pt-2.5 motion-safe:transition-[height] motion-safe:duration-700 motion-safe:ease-out"
          :class="entry.rank === 1 ? 'bg-beer text-night' : 'bg-edge text-slate-100'"
          :style="{ height: grown ? entry.height : '0px' }"
        >
          <span class="font-display text-[22px] font-extrabold sm:text-[26px]">{{ entry.rank }}</span>
          <span class="text-[13px] font-semibold sm:text-sm">{{ formatEuro(entry.value) }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Punishment from '@/types/Punischment';
import { formatEuro, readableTextOn } from '@/utils/format';
import { useGrow } from '@/composables/useGrow';

const props = defineProps<{ fines: Punishment[] }>();

// Platz 3 braucht mindestens Rang + Betrag (ca. 72px), sonst wird der Betrag abgeschnitten
const HEIGHTS = ['128px', '100px', '80px'];

const podium = computed(() => {
  const top = [...props.fines].sort((a, b) => b.value - a.value).slice(0, 3)
    .map((f, i) => ({ ...f, rank: i + 1, height: HEIGHTS[i] }));
  // Platz 2 links, Platz 1 in der Mitte, Platz 3 rechts
  const [first, second, third] = top;
  return first && second && third ? [second, first, third] : top;
});

const grown = useGrow(() => props.fines);
</script>
